export default "__VITE_ASSET__Dgogf9TG__"